module.exports = __webpack_public_path__ + "static/media/tzwalletlogo.c528bdb7.svg";